/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const lang = document.body.dataset.lang;

  const map_it = document.querySelector("#shopify-block-AUy9iVHhEV1pQVlBLQ__538e02d8-b716-45ce-b5e3-5d646046b846");
  const map_en = document.querySelector("#shopify-block-AMk9nVnpBTVdpZzRuV__83a1ff9e-f859-44b0-b40e-5eeb7b882921");
  map_it.style.display = 'none';
  map_en.style.display = 'none';

  // Verifica el idioma actual del sitio
  if (lang === 'en') {
    // Si el idioma es italiano, muestra el bloque italiano y oculta el bloque inglés
    map_it.style.display = 'none';
    map_en.style.display = 'block';
    } else {
    // Si el idioma es inglés, muestra el bloque inglés y oculta el bloque italiano
    map_it.style.display = 'block';
    map_en.style.display = 'none';
  }

  console.log("lang",lang,map_it,map_en);


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
